/**
 * Utility functions for cookie management
 */

/**
 * Get a cookie value by name
 */
export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
}

/**
 * Set a cookie
 */
export function setCookie(
  name: string,
  value: string,
  options: {
    maxAge?: number;
    path?: string;
    domain?: string;
    sameSite?: 'Strict' | 'Lax' | 'None';
    secure?: boolean;
  } = {}
): void {
  if (typeof document === 'undefined') return;
  
  const {
    maxAge = 30 * 24 * 60 * 60, // 30 days default
    path = '/',
    domain,
    sameSite = 'Lax',
    secure = false
  } = options;

  let cookie = `${name}=${value}; path=${path}`;
  
  if (maxAge) {
    cookie += `; max-age=${maxAge}`;
  }
  
  if (domain) {
    cookie += `; domain=${domain}`;
  }
  
  cookie += `; SameSite=${sameSite}`;
  
  if (secure) {
    cookie += '; Secure';
  }
  
  document.cookie = cookie;
}

/**
 * Delete a cookie
 */
export function deleteCookie(name: string, path: string = '/'): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

